const routes = [
    {
        path: "/scholarship/types",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "scholarshiptype_index"
        }
    }
];

export default routes;
